import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { GetGroupsAction } from '../../actions/groups/get-groups-action';
import { AddGroupAction } from '../../actions/groups/add-group-action';
import { AddGroupErrorAction } from '../../actions/groups/add-group-error-action';

@Injectable()
export class AddGroupEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public AddGroup = createEffect(() => this.actions
    .pipe(
      ofType(AddGroupAction.type),
      mergeMap(action => {
        const addGroupAction = <AddGroupAction>action;
        return this.api.addGroup(addGroupAction.bijbEvent, addGroupAction.group).then(() => {
          return new GetGroupsAction(addGroupAction.bijbEvent);
        }, error => {
          return new AddGroupErrorAction(error);
        });
      })
    ));
}
